import { render, staticRenderFns } from "./CommentFiles.vue?vue&type=template&id=7bf8e652&scoped=true"
import script from "./CommentFiles.vue?vue&type=script&lang=js"
export * from "./CommentFiles.vue?vue&type=script&lang=js"
import style0 from "./CommentFiles.vue?vue&type=style&index=0&id=7bf8e652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf8e652",
  null
  
)

export default component.exports